import axios from '@/libs/api.request'
import {
  getProductReferencePluginData,
  setProductReferencePluginData,
  deleteProductReferencePluginData
} from './plugin'

const loadProducts = (params) => {
  return axios.request({
    method: 'get',
    url: 'products',
    params: params
  })
}

const deleteProduct = (id) => {
  return axios.request({
    method: 'delete',
    url: `products/${id}`
  })
}

const generateProductNumber = (prefix, value = null) => {
  return axios.request({
    method: 'post',
    url: '/products/generate-product-number',
    data: { prefix: prefix, value: value }
  })
}

export {
  loadProducts,
  deleteProduct,
  generateProductNumber,
  getProductReferencePluginData,
  setProductReferencePluginData,
  deleteProductReferencePluginData
}
